const tz = 'Europe/Prague';

export function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit', timeZone: tz });
}

export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  const time = d.toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit', timeZone: tz });
  if (sameDay) return `dnes ${time}`;
  return `${d.toLocaleDateString('cs-CZ', { day: 'numeric', month: 'numeric', year: d.getFullYear() === today.getFullYear() ? undefined : 'numeric', timeZone: tz })} ${time}`;
}

export function fmtMs(ms: number | null | undefined): string {
  if (ms == null) return '–';
  return ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(1).replace('.', ',')} s`;
}

export function fmtParams(p: Record<string, unknown> | undefined): string {
  if (!p) return '–';
  const entries = Object.entries(p);
  if (!entries.length) return 'bez parametrů';
  return entries.map(([k, v]) => `${k}: ${typeof v === 'string' ? v : JSON.stringify(v)}`).join(', ');
}

/** České skloňování: plural(2, 'krok', 'kroky', 'kroků'). */
export function plural(n: number, one: string, few: string, many: string): string {
  return n === 1 ? one : n >= 2 && n <= 4 ? few : many;
}

const REASON: Record<string, string> = {
  role: 'vaše role na tento nástroj nemá právo',
  invalid_ticket: 'neplatný nebo prošlý ticket',
  no_rule: 'nástroj nemá v bráně pravidlo',
  bad_input: 'neplatné parametry',
  source_error: 'zdroj dat neodpověděl',
  m365_not_connected: 'pošta a soubory z Microsoft 365 nejsou propojené',
  source_forbidden: 'v Prdeli nemáte k těmto datům oprávnění',
  external_person: 'jen interní lidé',
  memory_policy: 'do paměti nepatří citlivé údaje (sazby, mzdy, HR, hesla)',
};

export function reasonText(reason: string | null | undefined): string {
  if (!reason) return '';
  return REASON[reason] ?? reason;
}

export function firstName(name: string): string {
  return name.split(/\s+/)[0] || name;
}

/** Oslovení v 5. pádě pro běžná česká jména; jinak beze změny. */
export function vocative(name: string): string {
  const n = firstName(name);
  const map: Record<string, string> = {
    Daniel: 'Danieli', Dan: 'Dane', Jan: 'Jene', Jana: 'Jano', Petr: 'Petře', Pavel: 'Pavle', Martin: 'Martine',
    Tomáš: 'Tomáši', Jakub: 'Jakube', Lucie: 'Lucie', Petra: 'Petro', Eva: 'Evo', Lukáš: 'Lukáši', Ondřej: 'Ondřeji',
  };
  return map[n] ?? n;
}
